function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M90 0v30H60v60H30V30H0V0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464646",
  d: "M120 0h60v30h-60zM180 60v30H90V30h30v30z"
});

function SvgTechcrunchLogoGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 180 90"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuNCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI0MHB4IiBoZWlnaHQ9IjIwcHgiIHZpZXdCb3g9IjAgMCAxODAgOTAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDE4MCA5MCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cjxwb2x5Z29uIGZmaWxsPSIjNDY0NjQ2IiBwb2ludHM9IjkwLDAgOTAsMzAgNjAsMzAgNjAsOTAgMzAsOTAgMzAsMzAgMCwzMCAwLDAgIi8+CjxyZWN0IHg9IjEyMCIgZmlsbD0iIzQ2NDY0NiIgd2lkdGg9IjYwIiBoZWlnaHQ9IjMwIi8+Cjxwb2x5Z29uIGZpbGw9IiM0NjQ2NDYiIHBvaW50cz0iMTgwLDYwIDE4MCw5MCA5MCw5MCA5MCwzMCAxMjAsMzAgMTIwLDYwICIvPgo8L3N2Zz4K";
export { SvgTechcrunchLogoGray as ReactComponent };